export const STUDENT_SET_INTERESTS = 'STUDENT_SET_INTERESTS';
export const STUDENT_SET_CATEGORIES = 'STUDENT_SET_CATEGORIES';
export const STUDENT_ADD_SELECTED_CATEGORY_ID = 'STUDENT_ADD_SELECTED_CATEGORY_ID';
export const STUDENT_REMOVE_SELECTED_CATEGORY_ID = 'STUDENT_REMOVE_SELECTED_CATEGORY_ID';
